import type { AccountProviderType } from 'owa-accounts-store';
import type { AccountsEditorSource } from './AccountsEditorSource';
import type { ObservableMap } from 'mobx';
import type { OwaDate } from 'owa-datetime';

export default interface AccountsEditorStore {
    /**
     * The account which is pending a true time status update
     */
    accountPendingTrueTimeUpdate: string;

    /**
     * The account which failed to update true time status
     */
    trueTimeUpdateFailedAccount: string;

    /**
     * accounts state with respect to editor
     */
    accountsEditorState: AccountsEditorState;

    /**
     * Whether or not user attempted to connect an account
     */
    connectAccountAttempted: boolean;

    /**
     * The selected account provider type
     */
    selectedAccountProvider: AccountProviderType;

    /**
     * The source hosting this component used for logging
     */
    source: AccountsEditorSource;

    /**
     * The timestamp when the calendar list starts to load
     */
    accountCalendarsLoadStartTime: number;

    /**
     * Accounts added in the current OWA session
     */
    owaSessionAddedAccountsTimestamps: ObservableMap<string, OwaDate>;

    /**
     * Accounts added in the current accounts editor session
     */
    editorSessionAddedAccounts: string[];

    /**
     * The accounts (in error state) referred to the editor (by the error dialog)
     */
    accountErrorReferralAccounts: string[];
}

export enum AccountsEditorState {
    None = 0,
    Adding = 1,
    Added = 2,
    AddFailedUnknown = 3,
    Removing = 4,
    Removed = 5,
    RemoveFailed = 6,
    ReconnectFailed = 7,
    AddFailedAadAuth = 8,
    AddFailedUserCancelled = 9,
    TrueTimeDisabled = 10,
}
